import { httpPost } from "./httpService";

export function listEnabledGraphs() {
  return httpPost("/graph/v1/listEnabledGraphs", {});
}

export function searchEntityDetail(entityId) {
  return httpPost("/graph/v1/searchEntityDetail", { entityId });
}

export function searchEntityRelationAgg(entityId, keywords = null) {
  return httpPost("/graph/v1/searchEntityRelationAgg", { entityId, keywords });
}
